import { SortDepType } from "../../../types";

export const initSortDep:SortDepType = {
    order: "severity"
}